import { getWindow } from '@ps/web-core-utils';
import Url from 'url-parse';

interface Query {
  [key: string]: string | undefined;
}

const generateGameUrl = (deepLinkConfig: object, resolver: string) => {
  if (!resolver) {
    return '';
  }

  const webPokerUrl = new Url(resolver);

  const query: Query = {
    standalonetable: 'true',
    args: getWindow()?.btoa(JSON.stringify(deepLinkConfig))
  };

  webPokerUrl.set('query', query);

  return webPokerUrl.toString();
};

export default generateGameUrl;
